import { render, staticRenderFns } from "./EditAllocation.vue?vue&type=template&id=944f901e&scoped=true"
import script from "./EditAllocation.vue?vue&type=script&lang=js"
export * from "./EditAllocation.vue?vue&type=script&lang=js"
import style0 from "./EditAllocation.vue?vue&type=style&index=0&id=944f901e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944f901e",
  null
  
)

export default component.exports